import React from 'react';
import ChartistGraph from 'react-chartist';
import '../../player-overview-charts/chartist.min.css';
import './chart-custom-theme.css';

class AngleChart extends React.Component {
  UNSAFE_componentWillMount() {
    this.setState({});
  }

  componentDidMount() {
    let anglesSequence = -1;
    if (this.props.result.angles_sequence) {
      anglesSequence = this.props.result.angles_sequence;
      this.setState({
        ...this.state,
        angles_sequence: anglesSequence.split(','),
        current_angle_index: 0,
      });
    }
  }

  startAnimating() {
    if (this.state.animation_interval && this.state.animation_interval !== -1) {
      return;
    }

    if (this.props.dynamic === false) {
      return;
    }

    const animationInterval = setInterval(this.animateChart.bind(this), 20);
    this.setState({
      ...this.state,
      animating: true,
      current_angle_index: 0,
      animation_interval: animationInterval,
    });
  }

  stopAnimating() {
    clearInterval(this.state.animation_interval);
    this.setState({
      ...this.state,
      animating: false,
      current_angle_index: 0,
      animation_interval: -1,
    });
  }

  animateChart() {
    if (!this.state.angles_sequence) {
      return;
    }

    const index = this.state.current_angle_index;
    const sequence = this.state.angles_sequence;
    if (index >= sequence.length) {
      this.stopAnimating();
      return;
    }

    let currentFrameData = this.state.angles_sequence[this.state.current_angle_index];

    let newAnimationFrame;
    let fillData;
    if (currentFrameData < 0) {
      currentFrameData *= -1;
      fillData = 90 - currentFrameData;
      newAnimationFrame = [fillData, currentFrameData, 0, 90];
    } else {
      fillData = 90 - currentFrameData;
      newAnimationFrame = [90, 0, currentFrameData, fillData];
    }

    this.setState({
      ...this.state,
      animationFrame: newAnimationFrame,
      current_angle_index: this.state.current_angle_index + 1,
    });
  }

  render() {
    const dynamic = typeof this.props.dynamic !== 'undefined' ? this.props.dynamic : true;

    let maxAngleLeft = Math.round(this.props.result.max_angle_left);
    let maxAngleRight = Math.round(this.props.result.max_angle_right);
    const anglesNotReachedLeft = 90 - maxAngleLeft;
    const anglesNotReachedRight = 90 - maxAngleRight;
    let seriesAll = [anglesNotReachedLeft, maxAngleLeft, maxAngleRight, anglesNotReachedRight];

    if (dynamic) {
      if (this.state.animating) {
        seriesAll = this.state.animationFrame;
        if (seriesAll) {
          maxAngleLeft = seriesAll[1];
          maxAngleRight = seriesAll[2];
        }
      }
    }

    const showText = typeof this.props.show_text !== 'undefined' ? this.props.show_text : true;
    if (typeof maxAngleLeft === 'undefined') {
      return (
        <div className="chart-spinner-container">
          <i className="fa fa-spinner fa-spin" />
        </div>
      );
    }

    const data = {
      series: seriesAll,
    };

    const options = {
      donut: true,
      donutWidth: 40,
      startAngle: 270,
      total: 360,
      showLabel: false,
    };
    const type = 'Pie';

    const leftLabel = this.props.result.hand === 0 ? 'Pronation' : 'Supination';
    const rightLabel = this.props.result.hand === 0 ? 'Supination' : 'Pronation';

    return (
      <div>
        {showText && (
          <div>
            <div className="angle_chart_title">Hand Used</div>
            <div>{this.props.result.hand === 0 ? 'Left' : 'Right'}</div>
            <div className="angle_chart_title">Angle Reach</div>
          </div>
        )}

        <div>
          <span style={{ marginRight: '7px' }}>
            {leftLabel}: <b>{maxAngleLeft}°</b>
          </span>
          <span>
            {rightLabel}: <b>{maxAngleRight}°</b>
          </span>
        </div>
        <div className="angle_chart_holder">
          <ChartistGraph data={data} options={options} type={type} />
          {dynamic && (
            <div className="angle_chart_buttons">
              {!this.state.animating && (
                <div onClick={this.startAnimating.bind(this)} className="angle_play_button angle_chart_button">
                  <i class="fa fa-play"></i>
                </div>
              )}
              {this.state.animating && (
                <div onClick={this.stopAnimating.bind(this)} className="angle_stop_button angle_chart_button">
                  <i class="fa fa-stop"></i>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default AngleChart;
